import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Grid } from 'honeygrid-types'

import { gridsQueryKey } from './useGrids'

export const useDeleteGrid = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const { organization } = useStytchOrganization()

	return useMutation({
		mutationFn: (gridId: Grid['uuid']) => {
			return authFetch(`workspaces/${organization?.organization_id}/grids/${gridId}`, {
				method: 'DELETE',
			})
		},
		onSuccess: () => {
			// Invalidate grids list for workspace
			queryClient.invalidateQueries({ queryKey: gridsQueryKey(organization?.organization_id) })
		},
	})
}
